import { withTranslation } from "i18n";
import { useRouter } from "next/router";
import React, { useState } from "react";
import { Button, Card, Col, Modal, Row } from "react-bootstrap";
import { commonStrigns, assessmentString, stringFiles } from "res/strings";
import { BsArrowLeftShort, BsArrowRightShort } from "react-icons/bs";
import { Box } from "styled-components/box";
import { useDispatch } from "react-redux";
import { setExamCounter, setIsUploadingFile } from "redux/onlineExam/onlineExam.actions";
import { BiBook } from "react-icons/bi";
import { MdDateRange, MdSubject } from "react-icons/md";
import { AiOutlineInfoCircle } from "react-icons/ai";

function PlanCard({
  t,
  title,
  description,
  subject,
  duration,
  courseName,
  startAtPersian,
  endAtPersian,
  isJoinToExam,
  courses,
  id
}) {
  const router = useRouter();
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const courseNames = courses.map(course => course.name)

  const routeName = router.pathname.search("onlineExam") === 1 ? "onlineExam" : "assignment"
  const routeID = router.pathname.search("onlineExam") === 1 ? "onlineExamID" : "assignmentID"


  return (
    <>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Body className="d-flex flex-column text-left">
          <p className="m-0">
            {t(assessmentString.assessmentStartQuestion)}
          </p>
          {/* <p className="m-0 text-danger text-left">
            {t(assessmentString.assessmentStartInfoQuestion)}
          </p>
          <p className="m-0 text-warning text-left">
            {t(assessmentString.assessmentStartInfoTwoQuestion)}
          </p> */}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => router.push(`/${routeName}/[${routeID}]`, `/${routeName}/${id}`)}
          >
            {t(assessmentString.start)}
          </Button>

          <Button variant="secondary" onClick={() => setShowModal(false)}>
            {t(commonStrigns.cancel)}
          </Button>
        </Modal.Footer>
      </Modal>
      <Card className="my-2">
        <Card.Header className="d-flex text-primary p-0 m-0">

          <Row className="w-100 p-1" >

            <Col  xs={8}>
            <p className="text-left m-0">{title}</p>

            </Col>


            <Col xs={4} className="p-0">
            {isJoinToExam && <Box
            onClick={() => {
              dispatch(setExamCounter(null))
              dispatch(setIsUploadingFile(false))
              setShowModal(true)
            }}
            className="d-flex justify-content-end align-items-center"
          >
            <p className="text-success m-0 ">{t(assessmentString.start)}</p>
            <Box width="1em" className="text-success">
              {process.env.NEXT_PUBLIC_RTL ? (
                <BsArrowLeftShort />
              ) : (
                <BsArrowRightShort />
              )}
            </Box>
          </Box>}
            </Col>
           
            </Row>




         
        </Card.Header>
        <Card.Body>
        
          <RowItem
            value={subject}
            label={t(assessmentString.subject)}
          >
            <MdSubject className="mx-1 text-primary" />

          </RowItem>
          <RowItem
            value={courses.length > 0 && courseNames.toString()}
            label={t(assessmentString.courseName)}
          >

            <BiBook className="mx-1 text-primary" />

          </RowItem>
          {description && <RowItem
            value={description}
            label={t(assessmentString.description)}
          >

            <AiOutlineInfoCircle className="mx-1 text-primary" />

          </RowItem>
          }
  <RowItem value={endAtPersian} label={t(assessmentString.endAt)} >

<MdDateRange className="mx-1 text-primary" />

</RowItem>

          <div className="d-flex justify-content-end mt-4">
            <MdDateRange className="mx-1 text-primary" />
            <p className="m-0 app-text-xs">{startAtPersian}</p>
          </div>

        </Card.Body>

      </Card>
    </>
  );
}

const RowItem = ({ label, value, children }) => {
  return (
    <Row className="my-1">
      <Col className="d-flex p-0 m-0 text-left align-items-center" xs={4}>
        {children}
        {label && <p className="m-0 text-secondary">{label}</p>}
      </Col>
      <Col className="d-flex p-0 m-0" xs={8}>
        <p className="text-left m-0">{value}</p>
      </Col>
    </Row>
  );
};

export default withTranslation(stringFiles.common)(PlanCard);
